import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { loginRoute } from 'App/common/routeLookup';
import { queryClient } from 'Shared/queryClient';
import SessionStorageService from 'App/services/SessionStorageService';
import AuthService from 'App/services/AuthService';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import AuthPage from 'App/components/AuthPage';

const LogoutStyle = styled('div')`
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

function Logout() {
    const navigate = useNavigate();
    const [logoutComplete, setLogoutComplete] = useState(false);
    const [ssoData, setSsoData] = useState(null);

    useEffect(() => {
        // Read SSO data before logout clears the session
        const jwt = SessionStorageService.getDecodedJwt();
        const companyPermissions = jwt?.data?.CompanyPermissions || {};

        // Clear walkme
        if (window.walkme) {
            window.walkme = {
                userId: undefined,
                userAge: undefined,
                email: undefined,
                fullName: undefined,
                privilegeAdmin: undefined,
                privilegeAssignment: undefined,
                privilegeProtocol: undefined,
                privilegeReports: undefined,
                companyName: undefined,
            };
        }

        queryClient.clear();

        const endSession = window?.dtrum?.endSession;
        if (typeof endSession === 'function') {
            endSession();
        }

        AuthService.logout().then(() => {
            if (companyPermissions.SsoEnabled) {
                const ssoLogoutUrl =
                    typeof companyPermissions.SsoLogout === 'string' ? companyPermissions.SsoLogout.trim() : '';

                if (ssoLogoutUrl !== '') {
                    // External URL — use window.location.href like the Angular controller
                    window.location.href = ssoLogoutUrl;
                } else {
                    // No logout URL — show the "logged out" message with optional login link
                    setSsoData({
                        SsoLogin: companyPermissions.SsoLogin || null,
                    });
                    setLogoutComplete(true);
                }
            } else {
                navigate(loginRoute, { replace: true });
            }
        });
    }, [navigate]);

    /**
     * When we finally pull out angular, remvoe this outer div
     */
    return (
        <AuthPage>
            <LogoutStyle>
                {logoutComplete && ssoData ? (
                    <div>
                        You have been logged out of TherigySTM.
                        {ssoData.SsoLogin ? (
                            <div>
                                If you would like to log back in <a href={ssoData.SsoLogin}>Click Here</a>.
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div>
                        <p className="title text-center">Signing out...</p>
                        <TherigyLoadingSpinner />
                    </div>
                )}
            </LogoutStyle>
        </AuthPage>
    );
}

export default Logout;
